import { useEffect, useState } from "react";
import { thi_timestamp, thi_date } from "./../../../services/Helper";
import ResultChart from "../ResultChart";

function AllTestResults({ results, oldResults }) {
  const [TableResults, setTableResults] = useState([]);
  useEffect(() => {
    const totalParams = Object.values(results).length;
    const resultHistory = 3;
    const comparedResults = Object.values(results).map((a, i) => {
      var old = oldResults.filter(
        (o) =>
          o.TESTID === a[0].TESTID ||
          thi_timestamp(o.DOTEST) < thi_timestamp(a[0].DOTEST),
      );

      old = old.slice(-(resultHistory * totalParams));
      old = old.reverse();
      old = old.filter((o) => a[0]["PARAMETERCODE"] === o.PARAMETERCODE);
      var results = old.map((o) => o.PARAMETERRESULT);
      var dates = old.map((o) => o.DOTEST);
      a[0]["RESULTS"] = results;
      a[0]["DATES"] = dates;
      return a;
    });
    setTableResults(comparedResults);
  }, [oldResults, results]);

  const getFormattedResult = (result, lower, upper) => {
    if (result === null) return result;
    const numResult = parseFloat(result);
    if (numResult <= lower || numResult >= upper) {
      return (
        <span style={{ color: "#dc3545", fontWeight: "bold" }}>{result}</span>
      );
    } else {
      return result;
    }
  };

  return (
    <div style={{ marginTop: "15px" }}>
      {Object.values(TableResults).map((r, i) => {
        const {
          PARAMETERNAME,
          RESULTS,
          DATES,
          NORMAL_RANGE,
          UNITS,
          LOWERVALUE,
          UPPERVALUE,
          PARAMETERRESULT,
        } = r[0];

        return (
          <div
            key={i}
            className="parameter-row"
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "0",
              borderBottom: "1px solid #e0e0e0",
              paddingBottom: "0",
              gap: "10px",
            }}
          >
            <div style={{ flex: "0 0 20%", fontSize: "22px", fontWeight: "300" }}>
              {PARAMETERNAME}
            </div>
            <div style={{ flex: "0 0 10%", textAlign: "center" }}>
              <div style={{ fontSize: "28px", fontWeight: "bold", color: "#0d6efd" }}>
                {getFormattedResult(PARAMETERRESULT, LOWERVALUE, UPPERVALUE)}
              </div>
            </div>
            {RESULTS.map((res, idx) => {
              const numResult = parseFloat(res);
              const isAbnormal = numResult <= LOWERVALUE || numResult >= UPPERVALUE;
              return (
                <div key={idx} style={{ flex: "0 0 10%", textAlign: "center" }}>
                  <div style={{ 
                    fontSize: "18px", 
                    fontWeight: "bold", 
                    color: isAbnormal ? "#dc3545" : "#6c757d" 
                  }}>{res}</div>
                  <div style={{ fontSize: "11px", color: "#999" }}>{DATES[idx] ? thi_date(DATES[idx]) : ''}</div>
                </div>
              );
            })}
            <div style={{ flex: "0 0 10%", textAlign: "center", fontSize: "14px", color: "#6c757d" }}>
              {NORMAL_RANGE}
            </div>
            <div style={{ flex: "0 0 8%", textAlign: "center", fontSize: "14px", color: "#6c757d" }}>
              {UNITS}
            </div>
            <div style={{ flex: "0 0 15%", textAlign: "center" }}>
              <ResultChart results={[PARAMETERRESULT, ...RESULTS]} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default AllTestResults;
